Vue.component('up-down-flag', {
    props: ['current_value','past_value'],
    template: `
        <i v-if="delta > 0" class="ei-arrow_up text-success"></i>
        <i v-else-if="delta < 0" class="ei-arrow_down text-danger"></i>
    `,
    computed: {
        delta() {
            return parseFloat(this.current_value) - parseFloat(this.past_value)
        }
    }

})